<template>
  <div class="container">
    <div class="tit">车牌号码</div>
    <div class="flex-centers">
      <!-- <van-field label="车牌号" placeholder="请输入车牌号" type="text" v-model="form.carNo" v-if="carShow">
        <div slot="label" class="flex-area">
          <span class="text-bold">车牌号</span>
          <span class="arrow-area" @click="show=true">
            <i class="text">{{areaText}}</i>
            <van-icon name="arrow-down" />
          </span>
          <span class="arrow-area" @click="showNo=true">
            <i class="text">{{areaNo}}</i>
            <van-icon name="arrow-down" />
          </span>
        </div>
      </van-field> -->
      <van-field
        v-show="!VIN_NUM[index].newcarshowif"
        maxlength="1"
        v-for="(item,index) in 8"
        :key="index"
        v-model="VIN_NUM[index][index]"
        :focus="focus_index === index"
        @click="KeyboardUp(index)"
        label-align="left"
        readonly
      />
      <div
         class="newcar"
         v-if="VIN_NUM[7].newcarshowif"
         maxlength="1"
        @click="VIN_NUM[7].newcarshowif = false"
      >
        <span>新能源</span>
        <div style="font-size: 18px;position: absolute;top: 13px;">+</div>
      </div>
    </div>
    <div class="bgkd" @click="KeyboardDown" v-if="iskeyboard"></div>
    <div class="keyboard-box" v-if="iskeyboard">
      <Vkeyboard @setkeyboard="setkeyboard" @GetcarNo="GetcarNo" @BackcarNo="BackcarNo"></Vkeyboard>
    </div>
    <div class="tit" style="margin-top: 40px;">手机号码</div>
    <div class="tel">
      <input
      placeholder="请输入手机号"
      type="number"
      @input="mobileChange"
      v-model="form.mobile"
      class="input"
      />
    </div>
    <div class="code">
      <input class="brcode" type="number" v-model="form.smsCode" placeholder="请输入验证码"/>
      <van-button
        class="codebtn"
        type="primary"
        @click="getCatcha"
        :disabled="downTime>0"
      >{{btnCodeText}}</van-button>
      <van-button class="large-button" type="primary" @click="handleSure" :loading="loading">确定添加</van-button>
      <van-button class="btn" type="primary" @click="goPersonal">返回</van-button>
    </div>
   <!--  <van-cell-group class="no-border no-back" v-if="nameShow">
      <van-field label="姓名" placeholder="请输入姓名" type="text" v-model="form.realname"></van-field>
    </van-cell-group>
    <van-cell-group class="no-border no-back" v-if="mobileShow">
      <van-field
        label="手机号"
        placeholder="请输入手机号"
        type="text"
        @input="mobileChange"
        v-model="form.mobile"
      ></van-field>
    </van-cell-group>
    <van-cell-group class="no-border no-back flex-button" v-if="codeShow">
      <van-field label="验证码" placeholder="请输入验证码" type="text" v-model="form.smsCode"></van-field>
      <van-button
        type="primary"
        color="#6495FE"
        @click="getCatcha"
        :disabled="downTime>0"
      >{{btnCodeText}}</van-button>
    </van-cell-group> -->
    <!-- <van-button class="large-button" type="primary" @click="handleSure" :loading="loading">确定</van-button> -->
    <!-- 车牌区域
    <van-popup v-model="show" position="bottom" :style="{ height: '50%' }">
      <div class="area-code">
        <van-button @click="getAreaText(v)" v-for="v in carData" :key="v" type="default">{{v}}</van-button>
      </div>
    </van-popup>
    车牌字母
    <van-popup v-model="showNo" position="bottom" :style="{ height: '50%' }">
      <div class="area-code">
        <van-button @click="getAreaNo(v)" v-for="v in carNo" :key="v" type="default">{{v}}</van-button>
      </div>
    </van-popup> -->
  </div>
</template>
<script>
/* import { carTitle, carNum } from "@/api/carData"; */
/* import wx from 'weixin-js-sdk'; */
import { mPattern, carParttern } from "@/assets/js/rules";
import Vkeyboard from '@/components/Vkeyboard.vue';
export default {
  name: "BindCar",
  components: { Vkeyboard },
  data () {
    return {
      form: {
        realname: "",
        carNo: "",
        mobile: "",
        smsCode: ""
      },
      VIN_NUM: [
       { 0: '', newcarshowif: false },
       { 1: '', newcarshowif: false },
       { 2: '', newcarshowif: false },
       { 3: '', newcarshowif: false },
       { 4: '', newcarshowif: false },
       { 5: '', newcarshowif: false },
       { 6: '', newcarshowif: false },
       { 7: '', newcarshowif: true }
      ], // 车牌号码
      focus_index: -1,
      tel_index: -1,
      iskeyboard: false,
      carNo: '',
      downTime: 0,
      areaText: "",
      areaNo: "",
      show: false, // 弹窗
      showNo: false, // 弹窗
      loading: false, // 菊花转
      backNo: "",
      codeShow: true,
      mobileShow: true,
      nameShow: false,
      carShow: true
    };
  },
  computed: {
    btnCodeText () {
      return this.downTime > 0 ? this.downTime + "s后重新获取" : "获取验证码";
    }
  },
  /* watch: {
    "form.carNo" (t) {
      // console.log(t);
      if (this.backNo === t) {
        return;
      }
      if (t) {
        this.form.carNo = t.toUpperCase();
        this.backNo = t;
      }
    }
  }, */
  mounted () {
    // console.log(this.carData);
    if (this.$route.query.type === "2") {
      // 增加车辆
      this.$route.meta.title = '添加爱车';
      this.mobileShow = false;
      this.codeShow = false;
      this.nameShow = false;
      this.getUserInfo();
      return;
    }
    if (this.$route.query.type === "5" || this.$route.query.type === "6" || this.$route.query.type === "7") {
      // 绑定手机号
      this.$route.meta.title = '绑定手机号';
      this.nameShow = false;
      this.carShow = false;
      return;
    }
    this.getUserInfo();
    this.getUserOrderInfo();
    console.log('1111');
  },
  methods: {
    goPersonal() {
      wx.miniProgram.redirectTo({ url: "/pages/Mine/PersonalCenter/index" });
    },
    setkeyboard(val) { // 控制键盘显示/隐藏
      this.iskeyboard = val;
    },
    GetcarNo(v) { // 键盘输入车牌
      if (this.focus_index === -1) {
        this.focus_index = 0;
      }
      this.VIN_NUM[this.focus_index][this.focus_index] = v;
      this.focus_index += 1;
    },
    BackcarNo() { // 车牌删除
      console.log(this.focus_index);
      if (this.focus_index > -1) {
        this.VIN_NUM[this.focus_index][this.focus_index] = '';
        this.focus_index -= 1;
      }
      console.log(this.focus_index);
    },
    KeyboardUp(val) {
      console.log(this.focus_index);
      this.iskeyboard = true;
      /* this.focus_index = val - 1; */
      this.focus_index = val;
    },
    KeyboardDown() {
      this.iskeyboard = false;
    },
    // 手机号更改
    mobileChange (e) {
      if (e === this.mobile) {
        this.codeShow = false;
      } else {
        this.codeShow = true;
      }
    },
    // 用户信息
    async getUserInfo () {
      try {
        let res = await this.request("/user/user/get", {});
        if (res.data.mobile && res.data.mobile !== "") {
          this.form.realname = res.data.realname;
          if (this.$route.query.type && this.$route.query.type === "1") {
            this.form.mobile = res.data.mobile;
            this.form.realname = res.data.realname;
            this.codeShow = false;
            this.mobile = res.data.mobile;
            return;
          }
          this.mobileShow = false;
          this.codeShow = false;
        }
      } catch (e) {
        this.$error(e.message);
      }
    },
    // 最新订单信息
    async getUserOrderInfo () {
      try {
        let res = await this.request("/user/userCar/getUser", {});
        // console.log(res);
        if (res.code === 1004) {
          // 信息不存在时
          return;
        }
        if (res) {
          if (res.data.realname && res.data.realname !== "") {
            this.form.realname = res.data.realname;
          }
          if (res.data.carNo && res.data.carNo !== "") {
            this.areaText = res.data.carNo.slice(0, 1);
            this.areaNo = res.data.carNo.slice(1, 2);
            this.form.carNo = res.data.carNo.slice(2);
            /* this.VIN_NUM[0][0] = this.areaText;
            this.VIN_NUM[1][1] = this.areaNo; */
          }
        }
      } catch (e) {
        this.$error(e.message);
      }
    },
    // 定时器
    countDown (that) {
      if (this.downTime === 0) {
      } else {
        this.downTime--;
        // 循环调用
        setTimeout(function () {
          that.countDown(that);
        }, 1000);
      }
    },
    // 获取验证码
    async getCatcha () {
      let param = this.form;
      if (!param.mobile) {
        this.$error("请输入手机号");
      } else if (!mPattern.test(param.mobile)) {
        this.$error("手机号格式有误");
      } else {
        let url = "/sms/smsCode/bindErpCar";
        if (!this.carShow) {
          url = "/pay/userOrder/verifyMobile";
        }
        if (this.$route.query.type === "6" || this.$route.query.type === "7") {
          url = "/pay/userOrder/verifyMobile";
        }
        let res = await this.request(url, {
          mobile: this.form.mobile
        });
        if (res.code === 0) {
          this.downTime = 60;
          let that = this;
          that.countDown(that);
        } else {
          this.$error("获取失败：" + res.msg);
        }
      }
    },
    // 获取区域车牌
    getAreaText (v) {
      this.areaText = v;
      this.show = false;
    },
    // 获取车牌字母
    getAreaNo (v) {
      this.areaNo = v;
      this.showNo = false;
    },
    // 验证表单
    testParam (param) {
      console.log(this.VIN_NUM);
      let carNo = this.VIN_NUM[0][0] + this.VIN_NUM[1][1] + this.VIN_NUM[2][2] + this.VIN_NUM[3][3] + this.VIN_NUM[4][4] + this.VIN_NUM[5][5] + this.VIN_NUM[6][6] + this.VIN_NUM[7][7];
      /* if (!param.realname && this.nameShow) {
        this.$error("请输入姓名");
        return false;
      } else  */
      console.log(carNo);
      if (!param.mobile && this.mobileShow) {
        this.$error("请输入手机号");
        return false;
      } else if (!mPattern.test(param.mobile) && this.mobileShow) {
        this.$error("手机号格式有误");
        return false;
      } else if (carNo.length<5 && this.carShow) {
        this.$error("车牌号校验错误");
        return false;
      } else if (!param.smsCode && this.codeShow) {
        this.$error("请输入验证码");
        return false;
      } else {
        return true;
      }
    },
    // 提交表单
    async handleSure () {
      if (this.testParam(this.form)) {
        this.loading = true;
        this.form.carNo = this.VIN_NUM[0][0] + this.VIN_NUM[1][1] + this.VIN_NUM[2][2] + this.VIN_NUM[3][3] + this.VIN_NUM[4][4] + this.VIN_NUM[5][5] + this.VIN_NUM[6][6] + this.VIN_NUM[7][7];
        let form = { ...this.form };
        /* if (!this.codeShow) {
          form.mobile = "";
        } */
        /* delete form.carNo;
        form.carNo = this.areaText + this.areaNo + this.form.carNo; */
        let url = "/user/userCar/bindAdd";
        if (!this.carShow) {
          url = "/user/user/bindUserOfMobile";
        }
        if (this.$route.query.type === "6" || this.$route.query.type === "7") {
          url = "/pay/userOrder/verifySmsCode";
        }
        console.log(this.form);
        let res = await this.request(url, {
          ...form
        });
        if (res.code === 0) {
          if (this.$route.query.type === "6") {
            this.$error("添加成功");
            setTimeout(() => {
              this.go(
                `/Activity/Normal/Order?id=${this.$route.query.id}&mobile=${this.form.mobile}&type=6`
              );
            }, 300);
            return;
          }
          if (this.$route.query.type === "7") {
            this.$error("添加成功");
            setTimeout(() => {
              this.go(
                `/ToCard?cardNewUserId=${this.$route.query.id}&mobile=${this.form.mobile}`
              );
            }, 300);
            return;
          }
          this.$error("添加成功");
          setTimeout(() => {
            this.go('/bindCar');
            this.loading = false;
          }, 500);
        } else {
          this.loading = false;
          this.$error(res.msg);
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";
/* @subr: 100%/8; */
.container {
  position: relative;
  width: 375px;
}
.tit {
  margin: 12px 0 16px 12px;
  color: #101010;
  font-size: 16px;
}
.flex-centers {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 12px;
  padding-right: 8px;
  .v {
    width: 28px;
    height: 40px;
    background-color: rgba(242, 242, 242, 1);
    border: 1px solid rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #101010;
    font-family: PingFangSC-regular;
    font-size: 14px;
    text-align: center;
  }
  .newcar {
    width: 32px;
    height: 28px;
    background-color: #37C983;
    border: 1px solid rgba(255, 255, 255, 1);
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    color: #fff;
    font-family: PingFangSC-regular;
    font-size: 9px;
    text-align: center;
    padding-top: 5px;
    padding-bottom: 5px;
    position: relative;
  }
}
.bgkd{
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: calc(86vh + 10px);
    background-color: #282828;
    opacity: 0.61;
    z-index: 10;
}
.keyboard-box {
    position: absolute;
    bottom: 10px;
    width: 100%;
    z-index: 12;
}
.flex-area {
  border-right: 1px solid #e6e6e6;
  .flex-center();
  justify-content: flex-start;
  white-space: nowrap;
  .text-bold {
    padding-right: 30px;
  }
  .arrow-area {
    margin-right: 20px;
    .flex-center();
    i {
      color: #3296fa;
      font-size: 13px;
      &.van-icon {
        font-size: 12px;
      }
    }
    .text {
      padding-right: 2px;
      font-style: normal;
    }
  }
}
.tel {
  padding-left: 12px;
  padding-right: 8px;
  .input {
    border: none;
    height: 40px;
    width: 341px;
    background-color: rgba(242, 242, 242, 1);
    border: 1px solid rgba(255, 255, 255, 1);
    padding-left: 10px;
    border-radius: 4px;
    font-size: 16px;
  }
}
.code {
  position: relative;
  height: 44px;
  padding-left: 12px;
  padding-right: 8px;
  margin-top: 30px;
  .brcode {
    border: none;
    height: 44px;
    width: 341px;
    border-radius: 4px;
    background-color: #F2F2F2;
    border: 1px solid rgba(255, 255, 255, 1);
    padding-left: 10px;
  }
  .codebtn {
    position: absolute;
    top: 6px;
    right: 15px;
    height: 36px;
    width: 128px;
    border-radius: 4px;
    background: #0093FD;
  }
}
.area-code {
  display: flex;
  flex-wrap: wrap;
  margin: 2.5%/2;
  .van-button {
    min-width: 10%;
    max-width: 10%;
    margin: 2.5%/2;
    padding: 0;
    line-height: 1;
    flex: 1;
  }
}
.large-button {
  /* position: ; */
  /* bottom: 280px;
  left: 50%; */
  /* transform: translateX(-50%); */
  width: 353px;
  height: 44px;
  display: block;
  font-size: 16px;
  letter-spacing: 1px;
  background: #0093FD;
  margin-top: 60px;
}
.btn {
  width: 353px;
  height: 44px;
  display: block;
  font-size: 16px;
  letter-spacing: 1px;
  background: #0093FD;
  margin-top: 30px;
}
/deep/ .van-cell {
  width: 34px;
  height: 40px;
  background-color: rgba(242, 242, 242, 1);
  border: 1px solid rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #101010;
  font-family: PingFangSC-regular;
  font-size: 14px;
  text-align: center;
  padding: 0;
}
/deep/ .van-field__control {
  text-align: center;
  color:#101010;
  -webkit-text-fill-color: #101010;
}

</style>